"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPosition = exports["default"] = void 0;

var getPosition = function getPosition(options) {
  return new Promise(function (resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
};

exports.getPosition = getPosition;
var _default = {
  getPosition: getPosition
};
exports["default"] = _default;